import { shape } from 'prop-types';
import React from 'react';
import { SkjemaSporsmal } from '../../ahv-schema';
import { emptyList } from '../../constants';

function ListItem({ eksternId, svar }) {
    const id = `${eksternId}-${svar.svarId.replace('.', '-')}`;
    return <li id={id}>{svar.tekst}</li>;
}

function ListEmpty() {
    return (
        <li className="ahv-textlist-empty">
            <em>Finner dessverre ingen næringskoder på organisasjonen</em>
        </li>
    );
}

function Textlist({ question }) {
    if (question.utfyllingsregel.regel !== 'KUN_LESING') {
        return (
            <p id="text-list-warning">
                <em>TEXT_LIST støtter bare utfyllingsregelen KUN_LESING.</em>
            </p>
        );
    }

    const aktiveSvar = question.muligeSvar ? question.muligeSvar.filter((svar) => svar.valgt) : emptyList;

    return (
        <ul className="ahv-textlist-selected-items">
            {aktiveSvar.length === 0 && <ListEmpty />}
            {aktiveSvar.map((svar) => (
                <ListItem eksternId={question.eksternId} svar={svar} key={svar.svarId} />
            ))}
        </ul>
    );
}

Textlist.propTypes = {
    question: shape(SkjemaSporsmal).isRequired,
};

export default Textlist;
